import React, { useEffect, useState } from 'react';

// Store hours in America/Chicago (Illinois).
// 0 = Sunday, 1 = Monday, ... 6 = Saturday
const HOURS = {
  0: { open: 11, close: 16 }, // Sun 11:00 AM – 4:00 PM
  1: { open: 10, close: 18 }, // Mon 10:00 AM – 6:00 PM
  2: { open: 10, close: 18 },
  3: { open: 10, close: 18 },
  4: { open: 10, close: 18 },
  5: { open: 10, close: 18 },
  6: { open: 10, close: 18 },
};

const fmtHour = (h) => {
  const period = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour} ${period}`;
};

const getNowInChicago = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).formatToParts(new Date());
  const m = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return {
    day: weekdayMap[m.weekday],
    hour: parseInt(m.hour, 10),
    minute: parseInt(m.minute, 10),
  };
};

const computeStatus = () => {
  const { day, hour, minute } = getNowInChicago();
  const today = HOURS[day];
  const decimal = hour + minute / 60;
  if (decimal >= today.open && decimal < today.close) {
    return { open: true, label: `Open now · Closes ${fmtHour(today.close)}` };
  }
  // Closed — find next opening.
  if (decimal < today.open) {
    return { open: false, label: `Closed · Opens today at ${fmtHour(today.open)}` };
  }
  const tomorrow = HOURS[(day + 1) % 7];
  return { open: false, label: `Closed · Opens tomorrow at ${fmtHour(tomorrow.open)}` };
};

const OpenStatusBadge = ({ className = '' }) => {
  const [status, setStatus] = useState(() => computeStatus());

  useEffect(() => {
    const id = setInterval(() => setStatus(computeStatus()), 60_000);
    return () => clearInterval(id);
  }, []);

  return (
    <span
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold ${className}`}
      style={{
        background: status.open ? 'rgba(16, 185, 129, 0.12)' : 'rgba(239, 68, 68, 0.1)',
        color: status.open ? '#059669' : '#dc2626',
      }}
      data-testid="open-status-badge"
    >
      <span
        className={`w-2 h-2 rounded-full ${status.open ? 'animate-pulse' : ''}`}
        style={{ background: status.open ? '#10b981' : '#ef4444' }}
      />
      {status.label}
    </span>
  );
};

export default OpenStatusBadge;
